import { message, Modal, Spin } from 'antd';
import React, { useContext, useEffect, useMemo, useState } from 'react';
import styles from './UserProfile.module.scss';
import Api from '../../../../api/Api';
import { ICurrentUser } from '../../../../typings/api';
import UserDetail from './UserDetail';
import { IUserProfile } from '../../../../typings/api';
import { StoreContext } from '../../../../store/store';
import { WaterdataGroup } from '../../../../typings/userGroupPermissions';
import moment from 'moment';
import { DatePFormat } from '../../../../generic/StaticVariable';

export interface IProps {
  close: () => void;
  user: ICurrentUser;
}

export default function UserProfile(props: IProps) {
  const context = useContext(StoreContext);
  const [userDetails, setUserDetails] = useState<IUserProfile>();
  const [subscription, setSubscription] = useState<{
    type: string,
    expiredDate: string
  }>({ type: '', expiredDate: '' });
  const [downloaderApiKey, setDownloaderApiKey] = useState('');
  const [loadingUserInfo, setLoadingUserInfo] = useState(false);

  const loading = useMemo(() => {
    return context.loadingDataFromBSApi || loadingUserInfo 
  }, [ context.loadingDataFromBSApi, loadingUserInfo  ])

  useEffect(() => {
    if (props.user && props.user.authenticated) {
      setLoadingUserInfo(true);
      prepareData();
    }
    if (
      props.user &&
      (props.user.isSubscriber ||
        props.user.waterdataGroup === WaterdataGroup.MOOD_Admin ||
        props.user.waterdataGroup === WaterdataGroup.Metocean_Plus)
    ) {
      getApiKey();
    }

    if(props.user && (props.user.subscriptionExpiryDate || props.user.subscriptionType)){
      setSubscriptionDetails()
    }
  }, [props.user]);

  const prepareData = React.useCallback(async () => {
    const result = await Api.currentUser.getUserProfile();
    result &&
      result.Result &&
      setUserDetails({
        ...result.Result,
        city: result.Result.companyInfo && result.Result.companyInfo.city ? result.Result.companyInfo.city : '',
        countryId: result.Result.companyInfo && result.Result.companyInfo.countryId
          ? result.Result.companyInfo.countryId
          : '',
        companyId: result.Result.companyInfo
          ? result.Result.companyInfo.vatNumber
          : '',
        stateId: result.Result.companyInfo && result.Result.companyInfo.stateId
          ? result.Result.companyInfo.stateId
          : '',
        sizeId: result.Result.companyInfo && result.Result.companyInfo.sizeId
          ? result.Result.companyInfo.sizeId
          : '', // "999992300",//
        segmentId: result.Result.companyInfo && result.Result.companyInfo.segmentId
          ? result.Result.companyInfo.segmentId
          : '', // "999992203"//
        zipcode: result.Result.companyInfo && result.Result.companyInfo.postalcode ? result.Result.companyInfo.postalcode : '',
        address1: result.Result.companyInfo && result.Result.companyInfo.address1 ? result.Result.companyInfo.address1 : '',
        address2: result.Result.companyInfo && result.Result.companyInfo.address2 ? result.Result.companyInfo.address2 : '',
        address3: result.Result.companyInfo && result.Result.companyInfo.address3 ? result.Result.companyInfo.address3 : '',
      });
    setLoadingUserInfo(false);
  }, [props.user]);

  function setSubscriptionDetails() {
    const subscriptionType = props.user.subscriptionType;
    const subscriptionExpired = props.user.subscriptionExpiryDate
    if (subscriptionExpired && subscriptionType) {
      const subscriptionExpiredDateObj = new Date(subscriptionExpired);
      const formattedSubscriptionDate = moment(subscriptionExpiredDateObj).format(DatePFormat);
      setSubscription({
        type: subscriptionType,
        expiredDate: formattedSubscriptionDate
      });
    }
  }

  async function getApiKey() {
    setSubscriptionDetails()
    const apiKey = await Api.currentUser.getApiKey();
    apiKey && setDownloaderApiKey(apiKey);
  }

  async function postUpdate(values: IUserProfile) {
    const data: any = await Api.auth.updateUserProfile(values);
    if (data && data.Result === 'Profile updated.') {
      context.setUserProfileUpdated(true);
      message.success('Your profile has been updated successfully!', 10);
    }
  }

  async function requestApiKey() {
    await Api.currentUser.registerDownloaderAPIKey();
    getApiKey();
  }

  return (
    <Modal
      className={styles.userProfileModal}
      title="Account information"
      visible={true}
      maskClosable={false}
      footer={null}
      onCancel={props.close}
      width={'75vw'}
    >
      {loading ? (
        <div className={styles.spinner}>
          <Spin size="large" />
        </div>
      ) : (
        <UserDetail
          data={userDetails}
          subscription={subscription}
          downloaderApiKey={downloaderApiKey}
          requestApiKey={requestApiKey}
          close={props.close}
          readOnly={false}
          postUpdate={postUpdate}
        />
      )}
    </Modal>
  );
}
